module.exports = __webpack_public_path__ + "static/media/Pizza.c66f6ea9.jpg";